import { toast } from "react-hot-toast";
import { useSupabaseCallback } from "../../../server/supabase/hooks";
import { useClaims } from "../../generic/hooks/use-claims";

import type { Json } from "../../../__definitions__/database-definitions";
import type { UUID } from "../../../utils/uuid";
import type { LexicalEditor, SerializedEditorState } from "lexical";

export function useHandleFollowUpLexicalError(
  id: UUID,
): (e: Error, editor: LexicalEditor, undoStack: SerializedEditorState[]) => Promise<void> {
  const claims = useClaims();

  const writeUndoStack = useSupabaseCallback(
    async ({ supabase }, e: Error, editor: LexicalEditor, undoStack: SerializedEditorState[]) => {
      console.error(e);
      toast.error(`Editor Error ${e.message}, please contact support.`);
      await supabase.rpc("log_corrupt_lexical_state", {
        identifier: {
          type: "follow_up",
          id,
          // oxlint-disable-next-line typescript/no-unsafe-type-assertion
          claims: (claims ?? null) as unknown as Json,
        },
        stack: {
          // oxlint-disable-next-line typescript/no-unsafe-type-assertion
          content: editor.getEditorState().toJSON() as unknown as Json,
          // oxlint-disable-next-line typescript/no-unsafe-type-assertion
          stack: undoStack as unknown as Json,
        },
      });
    },
    [id, claims],
  );

  return writeUndoStack;
}
